import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-apartment`

let api = {
  // token刷新
  refreshToken: `${baseUrl}/heartbeat/beating`,

  // 园区信息
  getYqInfo: `${baseUrl2}/yqInfo/getYqInfo`,

  // 园区基础数据
  getParkBaseInfo: `${baseUrl}/yqOverView/getYqBaseInfo`,

  // 历史车辆进出记录
  getCarRecentRecord: `${baseUrl}/iotData/getCarRecentRecord`,

  // 历史刷卡记录
  getSwingRecentRecord: `${baseUrl}/iotData/getSwingRecentRecord`,

  // 园区荣誉
  getHonorPage: `${baseUrl}/yqOverView/honor/getPage`,

  // 明星企业
  getStartEnterprise: `${baseUrl}/yqOverView/getStartEnterprise/明星企业`,

  // 企业产值税收
  getParkFinance: `${baseUrl}/yqOverView/getParkFinance`,

  // 顶部数据
  getStatisticData: `${baseUrl}/yqOverView/getStatisticData`,

  // 近五年企业入驻统计
  getEnterpriseEnterData: `${baseUrl}/enterpriseDevelop/getEnterpriseEnterData`,

  // 企业类别统计
  getEnterprisePatentData: `${baseUrl}/enterpriseDevelop/getEnterprisePatentData`,

  // 孵化信息数据
  getEnterpriseHatchData: `${baseUrl}/enterpriseDevelop/getEnterpriseHatchData`,

  // 报修
  getInteractionData: `${baseUrl}/yqService/getInteractionData`,

  // 巡检
  getInspectData: `${baseUrl}/yqService/getInspectData`,

  // 电子开票
  getInvoiceData: `${baseUrl}/yqService/getInvoiceData`,

  // 严选服务
  getValueAddedData: `${baseUrl}/yqService/getValueAddedData`,

  // 消息
  getMessageData: `${baseUrl}/yqService/getMessageData`,

  // 物联感知——设备管理
  getDeviceData: `${baseUrl}/iotData/getDeviceData`,

  // 物联感知——人行管理
  getPersonTrafficData: `${baseUrl}/iotData/getPersonTrafficData`,

  // 物联感知——车行管理
  getCarTrafficData: `${baseUrl}/iotData/getCarTrafficData`,

  // 物联感知——能耗管理
  getEngeryConsumptionData: `${baseUrl}/iotData/getEngeryConsumptionData`,

  // 物联感知——消防管理
  fscAlarmOverview: `${baseUrl}/iotData/fscAlarmOverview`,

  // 大华视频预览
  getVideoHlsStream: `${baseUrl3}/videoDevice/getVideoHlsStream`,

  // 获取所有楼栋列表
  getAllBuildings: `${baseUrl}/building/getAllBuildings`,

  // 获取楼栋下的楼层
  getFloorsByBuildingCode: `${baseUrl}/building/getFloorsByBuildingCode`,

  // 获取楼层下的企业
  getEnterpriseByFloorCode: `${baseUrl}/building/getEnterpriseByFloorCode`,

  // 企业画像——企业基础信息
  getKeyData: `${baseUrl}/enterprise/data/image/getKeyData`,

  // 企业画像——企业工商信息
  getBusinessData: `${baseUrl}/enterprise/data/image/getBusinessData`,

  // 企业画像——企业质量
  getRadarData: `${baseUrl}/enterprise/data/image/getRadarData`,

  // 企业画像——企业学历分布
  getEducationData: `${baseUrl}/enterprise/data/image/getEducationData`,

  // 企业画像——企业知识产权
  getIntellectualPropertyData: `${baseUrl}/enterprise/data/image/getIntellectualPropertyData`,

  // 企业画像——企业产值
  getOutputData: `${baseUrl}/enterprise/data/image/getOutputData`,

  // 企业画像——企业税收
  getTaxData: `${baseUrl}/enterprise/data/image/getTaxData`,

  // 企业画像——企业人员活跃度
  getActivityData: `${baseUrl}/enterprise/data/image/getActivityData`,

  // 企业画像——企业能耗趋势
  getEnergyUseData: `${baseUrl}/enterprise/data/image/getEnergyUseData`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/BigDataScreen.js